export const loadScriptAsync = (method, url) => {
    return new Promise((resolve, reject) => {
        const scriptTagId = `${method}-payment-handler-script`;
        let existingScript = document.getElementById(scriptTagId);
        if (existingScript) {
            resolve();
            return;
        }

        var tag = document.createElement('script');
        tag.id = scriptTagId;
        tag.src = url;
        tag.async = true;
        tag.onload = () => {
          resolve();
        };

        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      });
}